import "./Styles/Hero.css";
import { useEffect, useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";

import {
  FaPhoneAlt,
  FaEnvelope,
  FaWhatsapp
} from "react-icons/fa";

function Hero() {
  

  const slides = [
    {
      title: "Online Legal",
      highlight: "Consultation",
      subtitle: "Anytime Anywhere",
      button: "Consult Now",
      image:
        "https://images.unsplash.com/photo-1528747008803-4f6d3ea6d2f3?q=80&w=1974&auto=format&fit=crop",
      services: [
        "Divorce",
        "Property",
        "Employment Issues",
        "Criminal",
        "Consumer Protection",
      ],
    },

    {
      title: "Buy",
      highlight: "Property",
      subtitle: "with confidence",
      button: "Know More",
      image:
        "https://media.istockphoto.com/id/1254541892/photo/house-auction-to-law.jpg?b=1&s=170667a&w=0&k=20&c=rOvyfAXyPi2IxCAWVYqnOv6Th2mzfJYJ1F_MEfDqmEU=",
      services: [
        "Sale Agreement",
        "Sale Deed",
        "Property Report",
        "Drafting",
      ],
    },

    {
      title: "Document",
      highlight: "Drafting",
      subtitle: "by Expert Lawyer",
      button: "Get Started",
      image:
        "https://aegislaw.com/wp-content/uploads/2025/10/getty-images-VpqI6WX6sEs-unsplash-1-scaled.jpg",
      services: [
        "Gift Deed",
        "Lease Agreement",
        "Review & Consult",
      ],
    },

    {
      title: "Focus on building",
      highlight: "Startup",
      subtitle: "with confidence",
      button: "Know More",
      image:
        "https://www.idropnews.com/wp-content/uploads/2025/08/judges-desk-gavel-legal-court.jpg",
      services: [
        "Trademark",
        "Online Consultation",
        "Startup Documents",
      ],
    },
  ];

  const [current, setCurrent] = useState(0);
  const [activeFaq, setActiveFaq] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) =>
        prev === slides.length - 1 ? 0 : prev + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrent((prev) =>
      prev === slides.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrent((prev) =>
      prev === 0 ? slides.length - 1 : prev - 1
    );
  };

  return (
    <>
{/* HERO SECTION */}
<div className="home-banner-section">

  {slides.map((slide, index) => (
    <div
      key={index}
      className={
        index === current
          ? "home-banner-slide active"
          : "home-banner-slide"
      }
      style={{ backgroundImage: `url(${slide.image})` }}
    >

      {/* OVERLAY */}
      <div className="home-banner-overlay"></div>

      {/* CONTENT */}
      <div className="home-banner-container">

        <div className="home-banner-content">

          <h1 className="home-banner-title">
            {slide.title} <span>{slide.highlight}</span>
            <br />
            {slide.subtitle}
          </h1>

          <div className="home-banner-tagline">
            Consult in 10 Indian Languages,
            starting at just ₹31/min
          </div>

          <div className="home-banner-btn-row">

            <button className="home-banner-btn">
              {slide.button}
            </button>

            <div className="home-banner-online-card">

              <div className="home-banner-avatars">
                <img src="https://randomuser.me/api/portraits/women/44.jpg" alt="" />
                <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="" />
                <img src="https://randomuser.me/api/portraits/women/68.jpg" alt="" />
              </div>

              <span>+175 Online Lawyers</span>

              <div className="home-banner-green-dot"></div>

            </div>

          </div>

          <div className="home-banner-call-card">
            ☎ +26 Online Calls
            <div className="home-banner-yellow-dot"></div>
          </div>

          <div className="home-banner-features">

            <div className="home-banner-feature">
              <h4>Trusted</h4>
              <p>4.8 ★</p>
            </div>

            <div className="home-banner-feature">
              <h4>Secured</h4>
              <p>256bit encryption</p>
            </div>

            <div className="home-banner-feature">
              <h4>Convenient</h4>
              <p>24X7 Support</p>
            </div>

          </div>

          <div className="home-banner-services">

            <span className="home-banner-consult-title">
              CONSULT ON
            </span>

            {slide.services.map((item, i) => (
              <a href="/" key={i}>
                {item}
              </a>
            ))}

          </div>

        </div>

      </div>

    </div>
  ))}

  {/* ARROWS */}
  <button className="home-banner-prev-btn" onClick={prevSlide}>
    ❮
  </button>

  <button className="home-banner-next-btn" onClick={nextSlide}>
    ❯
  </button>

  {/* DOTS */}
  <div className="home-banner-dots">

    {slides.map((_, index) => (
      <span
        key={index}
        className={
          index === current
            ? "home-banner-dot active"
            : "home-banner-dot"
        }
        onClick={() => setCurrent(index)}
      ></span>
    ))}

  </div>

</div>

      {/* TRUSTED BY SECTION */}
      <div className="trusted-section">

        <div className="container">

          <h1 className="trusted-title">
            Trusted By over Million Users
          </h1>

          <div className="trusted-logos">

  <img
    src="https://cdn.worldvectorlogo.com/logos/ola-cabs.svg"
    alt="ola"
  />

  <img
    src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
    alt="basic"
  />

  <img
    src="https://cdn-icons-png.flaticon.com/512/1055/1055687.png"
    alt="moduleinnovation"
  />

  <img
    src="https://cdn-icons-png.flaticon.com/512/3079/3079165.png"
    alt="vekaria"
  />

  <img
    src="https://cdn-icons-png.flaticon.com/512/5968/5968705.png"
    alt="jodo"
  />

  <img
    src="https://cdn-icons-png.flaticon.com/512/5969/5969020.png"
    alt="springrole"
  />

</div>

        </div>

      </div>

      {/* OUR SERVICES SECTION */}
      <div className="our-services-wrapper">

        {/* Heading part */}
        <div className="our-services-head">

          <h2 className="our-services-title">
            Our Services
          </h2>

          <div className="vertical-line"></div>

          <div className="our-services-text">

            <p>
              Need expert consultation on Legal Matters? You're in the right place! Experienced legal professionals are here for you 24X7. Whether it's a small query or a big concern, experts are ready to help with clear & reliable advice in your Own Language.
            </p>

            <p>
              No legal jargon, just simple, straightforward support. Let us take the worry out of your legal matters.
            </p>

          </div>

        </div>

        {/* CARDS SECTION ADDED */}
        <div className="our-services-cards">

          <div className="service-card">

            <img
  src="https://cdn-icons-png.flaticon.com/512/2920/2920277.png"
  alt=""
/>

            <h3>Online Consultation with a Lawyer</h3>

            <p>
              Now consult a lawyer or get your legal documents reviewed anytime from the convenience of your home. With secure calls and verified Lawyers
            </p>

            <ul className="service-links">

              <li>
                <a href="/" className="service-pill">
                  ONLINE LAWYER CONSULTATION
                </a>
              </li>

              <li>
                <a href="/" className="service-pill">
                  DOCUMENT REVIEW & CONSULT
                </a>
              </li>

            </ul>

          </div>

          <div className="service-card">

            <img
  src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
  alt=""
/>

            <h3>Documentation by Expert Professional</h3>

            <p>
              Corporate, HR, professional or personal, Get any legal document drafted and customised to your business or personal needs in the most affordable way.
            </p>

            <ul className="service-links">

              <li>
                <a href="/" className="service-pill">
                  Relinquishment Deed
                </a>
              </li>

              <li>
                <a href="/" className="service-pill">
                  Commercial Lease Agreement
                </a>
              </li>

            </ul>

          </div>

          <div className="service-card">

            <img
  src="https://cdn-icons-png.flaticon.com/512/3202/3202926.png"
  alt=""
/>
            <h3>Check your challan status</h3>

            <div className="challan-input-box">

              <select className="country-code">
                <option>+91</option>
                <option>+1</option>
                <option>+44</option>
                <option>+971</option>
              </select>

              <input
                type="text"
                placeholder="Enter vehicle number"
                className="vehicle-input"
              />

            </div>

            <div className="challan-checkbox">
              <input type="checkbox" id="agree" />

              <label htmlFor="agree">
                *I agree to receive SMS, WhatsApp and email updates
              </label>
            </div>

            <button className="challan-btn">
              Get Details
            </button>

          </div>

          {/* CARD 4 - PROPERTY SOLUTIONS */}
          <div className="service-card">

            <img
  src="https://cdn-icons-png.flaticon.com/512/619/619153.png"
  alt=""
/>

            <h3>Property legal solutions for all your property investments</h3>

            <p>
              Trusted Property Legal Services. We help you take the right Property investment decisions.
              India's #1 Property Legal Solutions.
            </p>

            <ul className="service-links">
              <li><a href="/" className="service-pill">Sale Agreement</a></li>
              <li><a href="/" className="service-pill">Agreement to Sale Review</a></li>
              <li><a href="/" className="service-pill">Sale Deed Drafting</a></li>
              <li><a href="/" className="service-pill">Property Report</a></li>
            </ul>

          </div>

          {/* CARD 5 - STARTUP SOLUTIONS */}
          <div className="service-card">

            <img
  src="https://cdn-icons-png.flaticon.com/512/1055/1055687.png"
  alt=""
/>

            <h3>Start-up Legal Solutions</h3>

            <p>
              Planning a start-up or have an ongoing business? Focus on your business and leave legal worries on us.
              Consulting, Drafting, Review and Filing all under one roof.
            </p>

            <ul className="service-links">
              <li><a href="/" className="service-pill">Trademark</a></li>
            </ul>

          </div>

        </div>

        {/* =========================
    HOME ACHIEVEMENTS SECTION
========================= */}

<section className="home-achievement-section">

  <div className="home-achievement-wrapper">

    <div className="home-achievement-item">
      <h2>10 Million +</h2>
      <p>Consulting Minutes</p>
    </div>

    <div className="home-achievement-item">
      <h2>5 million pages</h2>
      <p>Drafted and Reviewed</p>
    </div>

    <div className="home-achievement-item">
      <h2>100,000</h2>
      <p>Start-up mentored</p>
    </div>

  </div>

</section>

        {/* QUICK BUY SECTION */}
        <div className="quick-buy-section">

          <div className="quick-buy-header">

            <h2>Quick Buy</h2>

            <div className="quick-buy-arrows">

              <button onClick={() => document.getElementById("quickScroll").scrollLeft -= 300}>
                ❮
              </button>

              <button onClick={() => document.getElementById("quickScroll").scrollLeft += 300}>
                ❯
              </button>

            </div>

          </div>

          <div className="quick-buy-container" id="quickScroll">

            <div className="quick-card">

              <img src="https://images.unsplash.com/photo-1521791136064-7986c2920216?w=800" alt="" />

              <div className="quick-card-top">
                <h3>Online Lawyer Consultation</h3>
                <p>⭐ 4.5</p>
              </div>

              <span>➜ Starting from Rs.31/min</span>

            </div>

            <div className="quick-card">

              <img src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800" alt="" />

              <div className="quick-card-top">
                <h3>Sale Agreement Review</h3>
                <p>⭐ 4.8</p>
              </div>

              <span>➜ Starting from Rs.2499</span>

            </div>

            <div className="quick-card">

              <img src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800" alt="" />

              <div className="quick-card-top">
                <h3>Agreement to Sale Drafting</h3>
                <p>⭐ 4.7</p>
              </div>

              <span>➜ Starting from Rs.3999</span>

            </div>

            <div className="quick-card">

              <img src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=800" alt="" />

              <div className="quick-card-top">
                <h3>Trademark Registration</h3>
                <p>⭐ 4.5</p>
              </div>

              <span>➜ Starting from Rs.10500</span>

            </div>

            <div className="quick-card">

              <img src="https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=800" alt="" />

              <div className="quick-card-top">
                <h3>Sale Deed Drafting</h3>
                <p>⭐ 4.6</p>
              </div>

              <span>➜ Starting from Rs.4999</span>

            </div>

            <div className="quick-card">

              <img src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800" alt="" />

              <div className="quick-card-top">
                <h3>➜ Relinquishment Deed</h3>
                <p>⭐ 4.5</p>
              </div>

              <span>Starting from Rs.6499</span>

            </div>

          </div>

        </div>

        {/* LegalAxis NEWS SECTION */}
        <div className="news-section">

          {/* LEFT SIDE */}
          <div className="news-left">

            <h2>LegalAxis in News</h2>

            <p>
              Our Success Stories in Media <br />
              Headlines and Lots of Encouragement
            </p>

          </div>

          {/* RIGHT SIDE */}
          <div className="news-grid">

            <div className="news-card">
              <img
  src="https://cdn-icons-png.flaticon.com/512/5968/5968885.png"
  alt="news"
/>
              <h3>Cardrates.com</h3>
              <p>
                LegalAxis Connects Individuals Seeking Legal Advice With Lawyers Who Can Answer Their Questions
              </p>
            </div>

            <div className="news-card">
              <img
  src="https://cdn-icons-png.flaticon.com/512/5968/5968841.png"
  alt="news"
/>
              <h3>Financial express</h3>
              <p>
                LegalAxis inks strategic partnership with Times Group’s Brand Capital
              </p>
            </div>

            <div className="news-card">
              <img
  src="https://cdn-icons-png.flaticon.com/512/732/732200.png"
  alt="news"
/>
              <h3>Your Story</h3>
              <p>
                Gurugram-based LegalAxis aims to become the Amazon of legal services
              </p>
            </div>

            <div className="news-card">
              <img
  src="https://cdn-icons-png.flaticon.com/512/5968/5968875.png"
  alt="news"
/>
              <h3>The News Minute</h3>
              <p>
                LegalAxis.com launches legal consultation in 8 Indian languages
              </p>
            </div>

            <div className="news-card">
              <img
  src="https://cdn-icons-png.flaticon.com/512/5968/5968866.png"
  alt="news"
/>
              <h3>The Economic Times</h3>
              <p>
                Legal-tech is disrupting Indian market faster than people’s anticipation
              </p>
            </div>

            <div className="news-card">
              <img
  src="https://cdn-icons-png.flaticon.com/512/732/732212.png"
  alt="news"
/>
              <h3>The Hindu</h3>
              <p>
                Online advice helps cut 45% litigation: LegalAxis
              </p>
            </div>

            <div className="news-card">
              <img
  src="https://cdn-icons-png.flaticon.com/512/5968/5968853.png"
  alt="news"
/>
              <h3>Business Standard</h3>
              <p>
                This entrepreneur is disrupting legal services space
              </p>
            </div>

            <div className="news-card">
              <img
  src="https://cdn-icons-png.flaticon.com/512/5968/5968866.png"
  alt="news"
/>
              <h3>Financial Express Tech Bytes</h3>
              <p>
                Seeking any legal advice? Now get instant consultation on LegalAxis.
              </p>
            </div>

          </div>

        </div>

        {/* TESTIMONIAL SECTION */}
        <div className="testimonial-section">

          {/* HEADING */}
          <div className="testimonial-header">

            <h2>
              Hear what our users have to say
            </h2>

            <div className="testimonial-arrows">
              <button>❮</button>
              <button className="active-arrow">❯</button>
            </div>

          </div>

          {/* CARDS */}
          <div className="testimonial-container">

            {/* CARD 1 */}
            <div className="testimonial-card">

              <div className="testimonial-user-img">
                <img
                  src="https://randomuser.me/api/portraits/men/32.jpg"
                  alt=""
                />
              </div>

              <p className="testimonial-text">
                "I've been using the LegalAxis app and it's really made dealing with legal stuff easier. It's great how I can just open the app and quickly find a legal expert to talk to, no matter what time it is. Every time I've had a question, big or small, I've gotten easy-to-understand answers from their experts. The app is super easy to use too, which is a big plus for me. I feel more confident handling legal things now. LegalAxis has been a big help!"
              </p>

              <div className="testimonial-bottom">

                <div>
                  <h3>Vijay Kanoor</h3>
                  <span>Bangalore, Karnataka</span>
                </div>

                <div className="stars">
                  ★★★★★
                </div>

              </div>

            </div>

            {/* CARD 2 */}
            <div className="testimonial-card">

              <div className="testimonial-user-img">
                <img
                  src="https://randomuser.me/api/portraits/men/45.jpg"
                  alt=""
                />
              </div>

              <p className="testimonial-text">
                "The Legal advice I get is straightforward and easy to understand, which is important for me. Using LegalAxis has taken away a lot of stress when it comes to legal matters. I definitely recommend it to anyone looking for quick and reliable legal help."
              </p>

              <div className="testimonial-bottom">

                <div>
                  <h3>Krishnamoorthy B</h3>
                  <span>Chennai, Tamil Nadu</span>
                </div>

                <div className="stars">
                  ★★★★★
                </div>

              </div>

            </div>

            {/* CARD 3 */}
            <div className="testimonial-card">

              <div className="testimonial-user-img">
                <img
                  src="https://randomuser.me/api/portraits/men/60.jpg"
                  alt=""
                />
              </div>

              <p className="testimonial-text">
                "The advocate I connected with on LegalAxis was incredibly helpful, clearing up many doubts I had. They offered solutions and insights into issues that were affecting my family and me. I've had such a positive experience that I wouldn't hesitate to recommend LegalAxis to my friends."
              </p>

              <div className="testimonial-bottom">

                <div>
                  <h3>Bhavesh Jain</h3>
                  <span>Jaipur, Rajasthan</span>
                </div>

                <div className="stars">
                  ★★★★☆
                </div>

              </div>

            </div>

          </div>

        </div>

        {/* FAQ SECTION */}
        <div className="faq-section">

          {/* LEFT SIDE */}
          <div className="faq-left">

            <h2>
              Questions? <br />
              We’re here to help
            </h2>

            <p>
              Check out our FAQs or talk to a live
              customer care specialist by phone,
              chat, or email.
            </p>

            <div className="faq-icons">

  <a href="/">
    <FaPhoneAlt />
  </a>

  <a href="/">
    <FaEnvelope />
  </a>

  <a href="/">
    <FaWhatsapp />
  </a>

</div>

          </div>

          {/* RIGHT SIDE */}
<div className="faq-right">

  {/* FAQ ITEM 1 */}
  <div className={`faq-item ${activeFaq === 0 ? "active" : ""}`}>

    <div
      className="faq-question"
      onClick={() => setActiveFaq(activeFaq === 0 ? null : 0)}
    >
      <h3>WHAT IS ONLINE LEGAL CONSULTATION?</h3>
      <span>{activeFaq === 0 ? "⌃" : "⌄"}</span>
    </div>

    {activeFaq === 0 && (
      <p className="faq-answer">
        Online Legal consultation or online Lawyer consultation is a method to connect Users and Lawyers virtually. It is a convenient and easy way to get online Lawyer advice using LegalAxis app.
      </p>
    )}

  </div>

  {/* FAQ ITEM 2 */}
  <div className={`faq-item ${activeFaq === 1 ? "active" : ""}`}>

    <div
      className="faq-question"
      onClick={() => setActiveFaq(activeFaq === 1 ? null : 1)}
    >
      <h3>ARE YOUR ONLINE LAWYERS QUALIFIED?</h3>
      <span>{activeFaq === 1 ? "⌃" : "⌄"}</span>
    </div>

    {activeFaq === 1 && (
      <p className="faq-answer">
        Yes, all lawyers are verified and experienced professionals with expertise in different legal areas.
      </p>
    )}

  </div>

  {/* FAQ ITEM 3 */}
  <div className={`faq-item ${activeFaq === 2 ? "active" : ""}`}>

    <div
      className="faq-question"
      onClick={() => setActiveFaq(activeFaq === 2 ? null : 2)}
    >
      <h3>WHAT HAPPENS IF I DON’T GET A RESPONSE FROM A LAWYER?</h3>
      <span>{activeFaq === 2 ? "⌃" : "⌄"}</span>
    </div>

    {activeFaq === 2 && (
      <p className="faq-answer">
        Our support team will help connect you with another available lawyer as quickly as possible.
      </p>
    )}

  </div>

  {/* FAQ ITEM 4 */}
  <div className={`faq-item ${activeFaq === 3 ? "active" : ""}`}>

    <div
      className="faq-question"
      onClick={() => setActiveFaq(activeFaq === 3 ? null : 3)}
    >
      <h3>HOW DO I START ONLINE CONSULTATION WITH LAWYER ON LegalAxis?</h3>
      <span>{activeFaq === 3 ? "⌃" : "⌄"}</span>
    </div>

    {activeFaq === 3 && (
      <p className="faq-answer">
        Simply choose your legal issue, connect with a lawyer, and start consultation through chat or call.
      </p>
    )}

  </div>

  {/* FAQ ITEM 5 */}
  <div className={`faq-item ${activeFaq === 4 ? "active" : ""}`}>

    <div
      className="faq-question"
      onClick={() => setActiveFaq(activeFaq === 4 ? null : 4)}
    >
      <h3>IS ONLINE LAWYER CONSULTATION SAFE AND SECURED ON LegalAxis?</h3>
      <span>{activeFaq === 4 ? "⌃" : "⌄"}</span>
    </div>

    {activeFaq === 4 && (
      <p className="faq-answer">
        Yes, all consultations are secure and your personal information remains confidential.
      </p>
    )}

  </div>

</div>
          </div>

          {/* OUR PARTNERS SECTION */}
<div className="partners-section">

  <h2 className="partners-title">Our Partners</h2>

  <div className="partners-logos">

  <img
    src="https://cdn.worldvectorlogo.com/logos/paytm-3.svg"
    alt="Paytm"
  />

  <img
    src="https://cdn.worldvectorlogo.com/logos/phonepe-1.svg"
    alt="PhonePe"
  />

  <img
    src="https://cdn.worldvectorlogo.com/logos/razorpay.svg"
    alt="Razorpay"
  />

  <img
    src="https://cdn.worldvectorlogo.com/logos/mobikwik.svg"
    alt="Mobikwik"
  />

  <img
    src="https://cdn.worldvectorlogo.com/logos/google-pay-1.svg"
    alt="Google Pay"
  />

  <img
    src="https://cdn.worldvectorlogo.com/logos/amazon-pay.svg"
    alt="Amazon Pay"
  />

</div>

</div>

        </div>

     
    </>
  );
}

export default Hero;